import React from 'react'
import Link from './helper/link'
import { Box, BoxBody, BoxHeader, BoxTitle } from './ui/box'
import { Col, Row } from './ui/grid'

interface Props {
    title: string
    featureName: string
}

export class UpgradeNecessary extends React.Component<Props> {
    public render() {
        return (
            <Row>
                <Col width={6} centered offsetMedium={3} widthSmall={12}>
                    <Box>
                        <BoxHeader>
                            <BoxTitle>{this.props.title}</BoxTitle>
                        </BoxHeader>

                        <BoxBody style={{ fontSize: '16px' }}>
                            <p>You are using a Tideways license for this project that does not include {this.props.featureName}.</p>

                            <p>If you want to use the advanced features please consider upgrading.</p>

                            <p className="text-center">
                                <Link route="XhprofBillingBundle.Billing.show" className="btn btn-success">
                                    Upgrade
                                </Link>
                            </p>
                        </BoxBody>
                    </Box>
                </Col>
            </Row>
        )
    }
}
